import React from "react";

// router and linker
import { Popconfirm, Switch } from "antd";

// state and sipatc
import { IGetBlogs } from "../../../store/types/blog";
import { destroy_blog, update_status } from "../../../services/apis/blog";
import { useAppDispatch } from "../../../store";
// import { useAppDispatch, useAppSelector } from "../../../store";
import { useNavigate } from "react-router-dom";

// constants
import { FaTrash } from "react-icons/fa";
import { LuHeart, LuMessageSquare } from "react-icons/lu";

type IBlogCard = {
  data: IGetBlogs;
};

const BlogCard: React.FC<IBlogCard> = ({ data }) => {
  // destroy_blog
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  // const loading = useAppSelector(({ blog }) => blog.loading);

  const handleStatusUpdate = async () => {
    await update_status(dispatch, data.id);
  };

  return (
    <div className="rounded-xl border-white shadow-md overflow-hidden">
      <div className="flex relative justify-center items-center">
        <img
          loading="lazy"
          src={data.image}
          alt={data.title}
          className="w-full h-48 object-cover"
        />
        <span
          className="absolute top-4 left-4 xl:top-3 xl:left-3 bg-primary-500 px-3 py-1 text-xs font-bold text-white rounded-full cursor-pointer "
          onClick={() => navigate(`/blog/${data.id}`)}
        >
          {data?.category?.name}
        </span>
        <Popconfirm
          title="Are you sure you want to delete!"
          onCancel={() => null}
          onConfirm={() => destroy_blog(dispatch, data.id)}
          className="absolute top-4 right-4 xl:top-3 xl:right-3 cursor-pointer "
        >
          <div className="bg-white/70 hover:bg-white p-2 rounded-full">
            <FaTrash color="red" size={16} />
          </div>
        </Popconfirm>
      </div>
      <div className="flex flex-col justify-between p-4 xl:p-3 overflow-hidden ">
        <h2
          className="text-xl font-bold cursor-pointer mb-3"
          onClick={() => navigate(`/blog/${data.id}`)}
        >
          {data.title}
        </h2>

        <div>
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="group flex items-center cursor-pointer">
                <LuHeart color="red" className="mr-1 " />
                <span>{data.likes_count}</span>
              </div>
              <div className="flex items-center cursor-pointer">
                <LuMessageSquare color="blue" className="mr-1" />
                <span>{data.comments_count}</span>
              </div>
            </div>
            <Switch
              checked={data.published?.toString() === "0" ? false : true}
              // loading={loading}
              onChange={handleStatusUpdate}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
